<div class="container-fluid finance-wrapper mt-4">

  <div class="row g-4">

    <!-- ================= NEW PRODUCT DEVELOPMENT ================= -->
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
      <div class="finance-card mb-3">
        <div class="finance-header" style="display:flex; justify-content: space-between;">
          <span><i class="fas fa-lightbulb"></i> New Product Development</span>
          <!-- ADD BUTTON -->
          <button class="btn btn-success btn-shadow btn-sm" (click)="addNewProduct()">+ Add New Product</button>
        </div>

        <hr />

        <!-- Rows -->
        <div *ngFor="let p of RNDD.newProducts; let i = index" class="row g-3 align-items-center mb-2">

          <!-- Product Name -->
          <div class="col-lg-5 col-md-5 col-sm-5 col-12">
            <label for="prodName" class="fw-semibold">Product Name</label>
            <input type="text" class="form-control form-control-sm" id="prodName" name="prodName" [(ngModel)]="p.productName"
              placeholder="Enter product name" />
          </div>

          <!-- Platform -->
          <div class="col-lg-5 col-md-5 col-sm-5 col-12">
            <label for="platform" class="fw-semibold">Platform</label>
            <select class="form-select form-control-sm" id="platform" name="platform" [(ngModel)]="p.platformId" [id]="'platform-' + i">
              <option [ngValue]="null" disabled>Select Platform</option>
              <option *ngFor="let plat of platformList" [ngValue]="plat.platformId">
                {{ plat.platformName }}
              </option>
            </select>
          </div>

          <!-- Remove -->
          <div class="col-lg-2 col-md-3 col-sm-3 col-12 text-center mt-4">
            <button class="btn btn-outline-danger btn-sm" (click)="removeProduct(i)"> ✕ Remove</button>
          </div>

        </div>
      </div>
    </div>



    <!-- ================= ONGOING R&D ================= -->
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">

      <div class="finance-card">
        <div class="finance-header">
          <i class="fas fa-cogs"></i>
          Ongoing Projects
        </div>

        <hr />

        <div class="table-responsive marketing-table-wrapper">

          <table class="table marketing-table align-middle text-center">
            <thead>
              <tr>
                <th class="text-start">
                  Project
                </th>

                <th>
                  % Completed
                </th>

                <th>
                  Select
                </th>
              </tr>
            </thead>

            <tbody>

              <tr *ngFor="let RnD of RNDD?.ongoingRnD">

                <td class="fw-semibold text-start">
                  {{ RnD.RnDName }}
                </td>

                <td>
                  {{ RnD.completion }} %
                </td>

                <td>

                  <input type="checkbox" class="form-check-input" [checked]="RnD.selected === 'Y'"
                    [disabled]="RnD.completion >= 100" (change)="toggleRnDSelection(RnD)" />

                </td>

              </tr>

            </tbody>

          </table>

        </div>

      </div>

    </div>

  </div>

</div>